/* @ngInject */

import { FEATURES } from '../../../common';

const MINIMUM_PASSWORD_LENGTH = 7;

export default class SetPasswordCtrl {
	constructor(
		$state,
		$timeout,
		NavigationService,
		LocalStorageService,
		NotificationService,
		AuthenticationService
	) {
		'ngInject';
		this.$state = $state;
		this.$timeout = $timeout;
		this.NavigationService = NavigationService;
		this.LocalStorageService = LocalStorageService;
		this.NotificationService = NotificationService;
		this.AuthenticationService = AuthenticationService;

		this.init();
	}

	init() {
		const profile = this.AuthenticationService.currentUser();

		this.isBusy = false;
		this.Password = undefined;
		this.ConfirmPassword = undefined;
		this.UserName = profile ? profile.UserName : undefined;
		this.passwordFieldType = 'password';
		this.confirmPasswordFieldType = 'password';
	}

	togglePasswordVisibility() {
		this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
	}

	toggleConfirmPasswordVisibility() {
		this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
	}

	get isPasswordLongEnough() {
		return !!this.Password && this.Password.length >= MINIMUM_PASSWORD_LENGTH;
	}

	get isPasswordConfirmed() {
		return !!this.Password && this.Password === this.ConfirmPassword;
	}

	get isValid() {
		return this.isPasswordLongEnough && this.isPasswordConfirmed;
	}

	cancel() {
		this.AuthenticationService.logout();
		this.$state.go(FEATURES.LOGIN);
	}

	async setPassword() {
		const session = this.LocalStorageService.retrieve('userSession');

		if (!session || !session.SessionToken) {
			this.NotificationService.error('SESSION EXPIRED. PLEASE LOG IN AGAIN.');
			this.$state.go(FEATURES.LOGIN);
			return;
		}

		this.isBusy = true;

		try {
			const outcome = await this.AuthenticationService.userSetPassword(
				session.SessionToken,
				this.UserName,
				this.Password
			);

			await this.AuthenticationService.adoptSession(outcome.Data);

			if (this.NavigationService.requiresPasswordSetup()) {
				this.NotificationService.error('PASSWORD WAS NOT SAVED. PLEASE CONTACT PRETOR GROUP.');
				return;
			}

			this.NotificationService.success('PASSWORD SET SUCCESSFULLY');
			this.$state.go(FEATURES.DASHBOARD);
		} catch (err) {
			console.error(`Error while setting a password for: ${this.UserName}`, err);
			this.NotificationService.error(
				(err && err.message) || 'COULD NOT SET PASSWORD. PLEASE CONTACT PRETOR GROUP.'
			);
		} finally {
			this.$timeout(() => {
				this.isBusy = false;
			});
		}
	}
}
